import call from "@/api/calls";
import mapMath from "./mapMath";
import LogRocket from "logrocket";

let currentPlaces, error;

class MapLoads {
  // return current loaded places
  getPlaces() {
    return Promise.resolve(currentPlaces);
  }

  // return current error
  getError() {
    return error;
  }

  // load relevant places based on position (origin) and zoom (distance)
  loadPlaces(origin, distance) {
    return call.group.area(origin, mapMath.zoomToArray(distance))
    .then(places => {
      return currentPlaces = places;
    })
    .catch(err => {
      LogRocket.captureException(err, {
        extra: {
          method: "loadPlaces",
          origin,
          distance
        }
      })
      return error = err;
    });
  }

}

const mapLoads = new MapLoads();
export default mapLoads;
